import * as React from 'react';
import Loader from '../Loader';
import { Route, Switch } from "react-router-dom";
import SkDrawerCalendar from './SkDrawerCalendar';
import SkDrawerCollection from './SkDrawerCollection';
import SkDrawerAuction from './SkDrawerAuction';
import SkDrawerStudio from './SkDrawerStudio';
import SkDrawerSettings from './SkDrawerSettings';

export default function SkDrawer(props) {
    return (
        <aside className="min-w-[450px] max-w-[450px] overflow-y-auto">
            <div className="border-[2px] border-[#262626] drawerHeight">

                <Switch fallback={<Loader />}>
                    <Route exact path={`${props.match.url}/calendar`}
                           render={ (props) => <SkDrawerCalendar {...props} /> } />
                    <Route exact path={`${props.match.url}/collection`}
                           render={ (props) => <SkDrawerCollection {...props} /> } />
                    <Route exact path={`${props.match.url}/studio`}
                           render={ (props) => <SkDrawerStudio {...props} /> } />
                    <Route path={`${props.match.url}/Playlists/:_id`}
                           render={ (props) => <SkDrawerStudio {...props} /> } />
                    <Route exact path={`${props.match.url}/auction`}
                           render={ (props) => <SkDrawerAuction {...props} /> } />
                    <Route exact path={`${props.match.url}/settings`}
                           render={ (props) => <SkDrawerSettings {...props} /> } />
                </Switch>
            </div>
        </aside>
    );
}